module.exports = __webpack_public_path__ + "static/media/process.f238e3b7.svg";